import axiosClient from './axiosClient';

export interface Banner {
    id: string;
    title: string;
    countdownDate: string; // Assuming ISO string from backend
    thumbnailOverlay?: string;
    isActive: boolean;
    createdAt?: string; // Assuming ISO string from backend
    updatedAt?: string; // Assuming ISO string from backend
}

export const fetchBannerApi = async (): Promise<Banner | null> => {
    try {
        const response = await axiosClient.get('/banners/main'); // Assuming an endpoint like /banners/main
        return response.data;
    } catch (error) {
        console.error("Error fetching banner:", error);
        return null;
    }
};
